export default () => ({
  isShown: false,
  editId: null,
  parentSidebarItems: [],
  menuList: [],
  isMenuEditable: {},
});
